export function allowCanvasKeyEventsListener(canvas: HTMLCanvasElement) {
	canvas.setAttribute('tabindex', '0');
}
